import { BasketballEvent, BasketballEventType } from '@hefe/models';
import { BasketballEventsSlice, ModalsSlice } from '@hefe/store';
import { BasketballEventColor } from '@hefe/ui';
import { formatTime } from '@hefe/utils';
import { Badge, Calendar, Space, Tooltip, Typography } from 'antd';
import { useAppDispatch } from '../../../../store/store';
import { t } from '@hefe/i18n';
import moment from 'moment';
import 'moment/locale/de';
import { useSelector } from 'react-redux';
import styles from './user-events-calendar.component.module.scss';

moment.locale('de');

export default function UserEventsCalendarComponent() {
  const dispatch = useAppDispatch();
  const filteredEvents = useSelector(
    BasketballEventsSlice.filteredBasketballUserEvents
  );

  const onEventClick = (event: BasketballEvent) => {
    if (event.type === BasketballEventType.GAME) {
      dispatch(
        ModalsSlice.modalsActions.openGameModal({
          id: parseInt(BasketballEventType.GAME + '_' + event.id),
        })
      );
    } else {
      // TODO implement Practice Modal
    }
  };

  const dateCellRender = (value: any): any => {
    const date = value.format('YYYY-MM-DD');
    const events = filteredEvents[date] as BasketballEvent[];
    const returnValue: any[] = [];

    if (events) {
      for (const event of events) {
        const color =
          event.type === BasketballEventType.PRACTICE
            ? BasketballEventColor.PRACTICE
            : BasketballEventColor.GAME;
        const description = BasketballEventType.PRACTICE
          ? t(event.description)
          : event.description;
        const text = event.teams.map((team) => team.name).join(', ');
        const time = formatTime(event.date);
        returnValue.push(
          <Tooltip
            key={event.id + '-' + event.type}
            title={description + ' | ' + event.location}
          >
            <Space size={0} onClick={() => onEventClick(event)}>
              <Badge color={color} />
              <Typography.Text className={styles['event-text']}>
                {time} - {text}
              </Typography.Text>
            </Space>
          </Tooltip>
        );
      }
    }

    return returnValue;
  };

  return <Calendar dateCellRender={dateCellRender} />;
}
